import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html'
})
export class DatepickerComponent implements OnInit {
  @Input() date: Date = new Date();
  @Output() selectedDate = new EventEmitter<Date>();

  constructor() {
  }

  ngOnInit(): void {

  }

}
